import { defineStore } from 'pinia'

export const useIndexStore = defineStore('store', () => {
  const route = null
  const notification = {}
  const user = null
  const projectId = -1
  const project = {}
  const projectName = null
  const snackbar = false
  const mapReady = false
  const token = localStorage.getItem('user-token') || ''
  const authStatus = ''
  const hasLoadedOnce = false

  function changeRoute (newRoute) {
    this.route = newRoute
  }
  function changeNotification (payload) {
    this.notification = payload
  }
  function changeUser (newUser) {
    this.user = newUser
  }
  function changeMapReady (value) {
    this.mapReady = value
  }
  function changeProjectId (projectId) {
    this.projectId = projectId
  }
  function changeProject (project) {
    this.project = project
  }
  function changeProjectName (projectName) {
    this.projectName = projectName
  }
  function closeNotification () {
    this.snackbar = false
  }
  function isAuthenticated () {
    return !!this.token
  }
  return {
    route,
    notification,
    user,
    projectId,
    project,
    projectName,
    snackbar,
    mapReady,
    token,
    authStatus,
    hasLoadedOnce,
    changeRoute,
    changeNotification,
    changeUser,
    changeMapReady,
    changeProjectId,
    changeProject,
    changeProjectName,
    closeNotification,
    isAuthenticated,
  }
})
